import { defineMessages } from 'react-intl';

export default defineMessages({
  intro: {
    defaultMessage: `Hello, who are you?`,
    id: 'app.testers.title'
  }
});



// WEBPACK FOOTER //
// ./src/containers/testers/messages.js